import { BASE_PUBLIC_API_ROOT_PATH, BASE_PUBLIC_V2_PATH } from '../../shared/public/constants/path.constants';

export const PUBLIC_PRODUCTS_API_PATHS = {
  GET_PRODUCTS: `${BASE_PUBLIC_API_ROOT_PATH}/products`,
  GET_PRODUCT_BY_ID: (productId: string) => `${BASE_PUBLIC_API_ROOT_PATH}/products/${productId}`,
};

export const PUBLIC_PRODUCTS_APP_PATHS = {
  CATALOG: `${BASE_PUBLIC_V2_PATH}/catalogue/:categorySlug`,
  CATALOG_FOR: (categorySlug: string) => `${BASE_PUBLIC_V2_PATH}/catalogue/${categorySlug}`,
  SEARCH: `${BASE_PUBLIC_V2_PATH}/recherche`,
  PRODUCT_DETAILS: `${BASE_PUBLIC_V2_PATH}/produits/:productId`,
  PRODUCT_DETAILS_FOR: (productId: string) => `${BASE_PUBLIC_V2_PATH}/produits/${productId}`,
};
